import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    console.error('[ErrorBoundary] getDerivedStateFromError:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] componentDidCatch:', {
      error: error.toString(),
      errorMessage: error.message,
      errorStack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString()
    });

    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '2rem',
          background: '#fff',
          color: '#000',
          minHeight: '100vh'
        }}>
          <h1 style={{ color: 'red' }}>🚨 Component Error</h1>
          <h2>Something went wrong rendering this component</h2>

          <div style={{
            background: '#f5f5f5',
            padding: '1rem',
            borderRadius: '8px',
            marginTop: '1rem',
            fontFamily: 'monospace',
            fontSize: '12px',
            overflow: 'auto'
          }}>
            <strong>Error:</strong>
            <pre>{this.state.error?.toString()}</pre>

            <strong>Error Message:</strong>
            <pre>{this.state.error?.message}</pre>

            <strong>Stack Trace:</strong>
            <pre style={{ fontSize: '10px', maxHeight: '200px', overflow: 'auto' }}>
              {this.state.error?.stack}
            </pre>

            {this.state.errorInfo && (
              <>
                <strong>Component Stack:</strong>
                <pre style={{ fontSize: '10px', maxHeight: '200px', overflow: 'auto' }}>
                  {this.state.errorInfo.componentStack}
                </pre>
              </>
            )}
          </div>

          <button
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
              if (this.props.onClose) this.props.onClose();
            }}
            style={{
              marginTop: '1rem',
              padding: '0.75rem 1.5rem',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            Go Back
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
